import { render, staticRenderFns } from "./Reference.vue?vue&type=template&id=f1c6b258&"
import script from "./Reference.vue?vue&type=script&lang=ts&"
export * from "./Reference.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports